exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard[data-v-45c68de3]{max-width:56em;width:100%}.flex-center[data-v-45c68de3]{padding:1.2em;display:flex;justify-content:center}", ""]);

// exports
